import { render, staticRenderFns } from "./FaceSaggingTemplate.vue?vue&type=template&id=bced38e8&scoped=true"
import script from "./FaceSaggingTemplate.vue?vue&type=script&lang=js"
export * from "./FaceSaggingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bced38e8",
  null
  
)

export default component.exports